import axiosInstance from "api/axiosInstance"
import SAlert from "components/Alert"
import { commodityClassificationAction } from "./commodity-classification-slice"
import { batch } from "react-redux"
import exportAxiosInstance from "api/exportAxiosInstance"
import FileSaver from "file-saver"

export const getCommodityClassifications =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  dispatch => {
    dispatch(commodityClassificationAction.setLoading(true))
    url = url || "/v1/commodity-classifications"
    axiosInstance
      .get(url, {
        params: {
          pageNumber,
          according,
          search,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(commodityClassificationAction.setError(null))
            dispatch(commodityClassificationAction.setData(response.data))
            dispatch(commodityClassificationAction.setLoading(false))
          })
        }
      })
      .catch(() => {
        dispatch(commodityClassificationAction.setLoading(false))
      })
  }

export const deleteCommodityClassification = id => dispatch => {
  dispatch(commodityClassificationAction.setLoading(true))
  axiosInstance
    .delete(`/v1/commodity-classifications/${id}`)
    .then(() => {
      dispatch(getCommodityClassifications())
      SAlert({
        title: "Success",
        text: "Unit Classification successfully deleted",
      })
      batch(() => {
        dispatch(commodityClassificationAction.setError(null))
        dispatch(commodityClassificationAction.setLoading(false))
      })
    })
    .catch(() => {
      dispatch(commodityClassificationAction.setLoading(false))
    })
}

export const storeCommodityClassification = (data, navigate) => dispatch => {
  dispatch(commodityClassificationAction.setLoading(true))
  axiosInstance
    .post("/v1/commodity-classifications", data)
    .then(() => {
      navigate("/commodity-classifications")
      SAlert({
        title: "Success",
        text: "Unit Classification successfully inserted",
      })
      batch(() => {
        dispatch(commodityClassificationAction.setError(null))
        dispatch(commodityClassificationAction.setLoading(false))
      })
    })
    .catch(err => {
      dispatch(commodityClassificationAction.setLoading(false))
      dispatch(
        commodityClassificationAction.setError(err?.response?.data?.errors)
      )
    })
}

export const updateCommodityClassification =
  (id, data, navigate) => dispatch => {
    dispatch(commodityClassificationAction.setLoading(true))
    axiosInstance
      .put(`/v1/commodity-classifications/${id}`, data)
      .then(() => {
        navigate("/commodity-classifications")
        SAlert({
          title: "Success",
          text: "Unit Classification successfully updated",
        })
        batch(() => {
          dispatch(commodityClassificationAction.setError(null))
          dispatch(commodityClassificationAction.setLoading(false))
        })
      })
      .catch(error => {
        dispatch(commodityClassificationAction.setLoading(false))
        dispatch(
          commodityClassificationAction.setError(error?.response?.data?.errors)
        )
      })
  }

export const getByIdCommodityClassification = id => dispatch => {
  dispatch(commodityClassificationAction.setLoading(true))
  axiosInstance
    .get(`/v1/commodity-classifications/${id}`)
    .then(response => {
      batch(() => {
        dispatch(commodityClassificationAction.setError(null))
        dispatch(commodityClassificationAction.setLoading(false))
        dispatch(
          commodityClassificationAction.setCommodityClassification(
            response.data
          )
        )
      })
    })
    .catch(() => {
      dispatch(commodityClassificationAction.setLoading(false))
    })
}

export const exportCommodityClassifications = search => dispatch => {
  dispatch(
    commodityClassificationAction.setExportStatus({
      loading: true,
      error: null,
    })
  )
  exportAxiosInstance
    .get("/v1/commodity-classifications-export", {
      params: { search },
    })
    .then(response => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        })
        FileSaver.saveAs(
          dataBlob,
          `Commodity-Classifications-${Math.random().toString()}.xlsx`
        )
        dispatch(
          commodityClassificationAction.setExportStatus({
            loading: false,
            error: null,
          })
        )
      }
    })
    .catch(error => {
      dispatch(
        commodityClassificationAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      )
    })
}
